export const federalDistricts = [
  {
    title: 'Центральный',
    subjects: [
      'RU-BEL', 'RU-BRY', 'RU-VLA', 'RU-VOR', 'RU-IVA', 'RU-KLU', 'RU-KOS',
      'RU-KRS', 'RU-MOS', 'RU-ORL', 'RU-RYA', 'RU-SMO', 'RU-TAM', 'RU-TVE',
      'RU-TUL', 'RU-YAR', 'RU-MSK'
    ],
    color: '#8fa433'
  },
  {
    title: 'Северо-Западный',
    subjects: [
      'RU-KR', 'RU-KO', 'RU-ARK', 'RU-VLG', 'RU-KGD', 'RU-LEN', 'RU-MUR',
      'RU-NGR', 'RU-PSK', 'RU-NEN', 'RU-SPB'
    ],
    color: '#257275'
  },
  {
    title: 'Южный',
    subjects: [
      'RU-AD', 'RU-KL', 'RU-KRM', 'RU-KDA', 'RU-AST', 'RU-VGG', 'RU-ROS', 'RU-SEV'
    ],
    color: '#9C306D'
  },
  {
    title: 'Северо-Кавказский',
    subjects: [
      'RU-DA', 'RU-IN', 'RU-KB', 'RU-KC', 'RU-SE', 'RU-CE', 'RU-STA'
    ],
    color: '#533184'
  },
  {
    title: 'Приволжский',
    subjects: [
      'RU-BA', 'RU-ME', 'RU-MO', 'RU-TA', 'RU-UD', 'RU-CU', 'RU-PER',
      'RU-KIR', 'RU-NIZ', 'RU-ORE', 'RU-PNZ', 'RU-SAM', 'RU-SAR', 'RU-ULY'
    ],
    color: '#2F9936'
  },
  {
    title: 'Уральский',
    subjects: [
      'RU-KGN', 'RU-SVE', 'RU-TYU', 'RU-CHE', 'RU-KHM', 'RU-YAN'
    ],
    color: '#f1ad10'
  },
  {
    title: 'Сибирский',
    subjects: [
      'RU-AL', 'RU-TY', 'RU-KK', 'RU-ALT', 'RU-KYA', 'RU-IRK', 'RU-KEM',
      'RU-NVS', 'RU-OMS', 'RU-TOM'
    ],
    color: '#314B82'
  },
  {
    title: 'Дальневосточный',
    subjects: [
      'RU-BU', 'RU-SA', 'RU-ZAB', 'RU-KAM', 'RU-PRI', 'RU-KHA', 'RU-AMU',
      'RU-MAG', 'RU-SAK', 'RU-YEV', 'RU-CHU'
    ],
    color: '#ef7c23'
  }
]
